import classNames from 'classnames';
import React from 'react';

interface Props {
    top?: React.ReactNode;
    position?: 'sticky';
    maxWidthVariation?: string;
    children: React.ReactNode;
}

const Footer = React.forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
    const { top, maxWidthVariation = 'desktop', position = 'sticky' } = props;

    return (
        <div className={`footer-bar footer-bar--${position} max--${maxWidthVariation}`} ref={ref}>
            {top && top}
            <div className="footer-bar__inner">{props.children}</div>
        </div>
    );
});

interface ElementProps {
    cols?: number;
    align?: string;
    verticalPadding?: boolean;
    children: React.ReactNode;
}

function Element({ cols = 12, align = 'left', verticalPadding = true, children }: ElementProps) {
    function getStyles() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles: { [key: string]: any } = {
            textAlign: align,
        };

        if (!verticalPadding) {
            styles.paddingTop = 0;
            styles.paddingBottom = 0;
        }

        return styles;
    }

    function getClasses() {
        const classes = ['footer-bar__element'];

        if (cols) {
            ['small', 'medium', 'normal', 'large'].forEach((size) => {
                classes.push(`${size}-${cols}`);
            });
        }

        return classNames(classes);
    }

    return (
        <div style={getStyles()} className={getClasses()}>
            {children}
        </div>
    );
}

export { Footer, Element };
